<template>
  <div class="page-wrap">
    <div>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>渠道档案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="6" style="padding-left: 20px;">
        <div
          style="background: white;padding: 20px 20px 20px 20px;height: 100%;margin-top: 20px;min-height: 840px;border-radius: 12px;">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small">
          </el-input>

          <el-tree class="filter-tree" :data="treeData" :props="defaultProps" default-expand-all
            :filter-node-method="filterNode" ref="tree" @node-click="treeClick">
          </el-tree>
        </div>
      </el-col>
      <el-col :span="18" style="padding-left: 20px;padding-right: 20px;">
        <div style="background: white;padding: 20px 20px 20px 20px;height: 100%;margin-top: 20px;border-radius: 12px;">
          <div style="overflow: hidden;">
            <h3 class="shop-name" v-if="hcmShopData && hcmShopData.dealername && isType == 2">{{ hcmShopData.dealername
            }}
            </h3>
            <h3 class="shop-name" v-if="hcmShopData && hcmShopData.shopName && isType == 1">{{ hcmShopData.shopName }}
            </h3>
            <div>
              <div style="float: left;width: 600px;border-right: 1px solid #eee;margin-top: 8px;">
                <div style="float: left;margin-bottom: 8px;width: 600px;">
                  <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                    src="@/assets/img/login/login_acc.png" />
                  <div style="float: left;width: 60px;font-size: 14px;">
                    用户名
                  </div>
                  <div style="float: left;margin-right: 16px;" v-if="hcmShopData && hcmShopData.username">
                    {{ hcmShopData.username }}
                  </div>
                  <div style="float: left;font-size: 14px;">
                    <span class="state" :class="hcmShopData.status == 1 ? 'active-state' : 'inactive-state'">{{
                      hcmShopData.status ==
                        1 ? '已启用' : '未启用' }}</span>
                  </div>
                </div>
                <div style="float: left;margin-bottom: 8px;width: 600px;">
                  <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                    src="@/assets/img/login/newWx.png" />
                  <div style="float: left;width: 60px;font-size: 14px;">
                    微信
                  </div>
                  <div style="float: left;margin-right: 16px;font-size: 14px;">
                    {{ hcmShopData.nickname ? hcmShopData.nickname : '未绑定' }}
                  </div>
                </div>
                <div style="float: left;margin-bottom: 8px;width: 600px;">
                  <img style="float: left;margin-right: 16px;width: 24px;height: 24px;"
                    src="@/assets/img/login/phone.png" />
                  <div style="float: left;width: 60px;font-size: 14px;">
                    手机
                  </div>
                  <div style="float: left;margin-right: 16px;font-size: 14px;">
                    {{ hcmShopData.mobile ? hcmShopData.mobile : '未绑定' }}
                  </div>
                </div>
              </div>
              <div style="float: right;height: 96px;line-height: 96px;text-align: center;width: 160px;">
                <span style="color: #999;margin-right: 16px;font-size: 14px;">信用积分</span>
                <span style="font-size: 24px;margin-left: 8px;font-size: 14px;"
                  v-if="hcmShopData.shopscore && isType == 1">{{ Number(hcmShopData.shopscore).toFixed(1) }}</span>
                <span style="font-size: 24px;margin-left: 8px;font-size: 14px;"
                  v-if="hcmShopData.score && isType == 2">{{ Number(hcmShopData.score).toFixed(1) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="background: white;padding: 20px 20px 20px 20px;height: 100%;margin-top: 20px;border-radius: 12px;">
          <section class="content-warpper tabs-wrapper" style="min-height:612px;" v-show="isType == 1">
            <!-- tab切换详情 -->
            <tabsDetail ref="tabs" :shopdealerid="shopdealerid" :newhcmShopData="hcmShopData" />
            <div class="nodata" v-if="!hcmShopData.shopName">
              <img src="@/assets/img/other/nodata.svg">暂无数据
            </div>
          </section>
          <section v-show="isType == 2">
            <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="loading">
              <el-tab-pane label="基本信息" name="1" class="tabs-basic" style="font-size: 14px;">
                <div style="background-color: white;padding: 20px;border-radius: 16px;">
                  <p v-for="(field, i) in gridColumns" :key="i" v-show="!isEdit">
                    <span v-if="field.prop == 'address'">
                      <span class="label">{{ field.label }}:</span>
                      {{ getAddress }}
                    </span>
                    <span v-else-if="field.prop == 'level'">
                      <span class="label">{{ field.label }}:</span>
                      {{ modalInfo.detail.level }}
                    </span>
                    <span v-else-if="field.prop == 'hlevelid'">
                      <span class="label">{{ field.label }}:</span>
                      {{ modalInfo.detail.hlevelname }}
                    </span>
                    <span v-else>
                      <span class="label">{{ field.label }}:</span>
                      {{ modalInfo.detail[field.prop] ? modalInfo.detail[field.prop] : '' }}
                    </span>
                  </p>
                  <el-button @click="editHandle" type="primary" size="small" style="margin-left: 122px;"
                    v-show="!isEdit">编辑</el-button>
                  <xinmingm :modalInfo="editModalInfo" v-show="isEdit" @showEdit="showEdit" @reqDetail="reqDetail"
                    @reqTableData="$emit('reqTableData')" />
                </div>
              </el-tab-pane>
              <el-tab-pane label="授权店铺" name="2">
                <el-row :gutter="20">
                  <el-col :span="12" v-for="(item, i) in hcmShopList" :key="i">
                    <div
                      style="background-color: white;padding: 20px;height: 65px;margin-bottom: 20px;border-radius: 16px;border: 1px solid #ccc;">
                      <div>
                        <span style="font-size: 16px;font-weight: 600;">
                          {{ item.shopName }}
                        </span>
                        <span style="font-size: 14px;padding-left: 12px;color: #606266;">
                          {{ item.wangwang }}
                        </span>
                      </div>
                      <div style="float: left;height: 48px;line-height: 48px;width: 100%;">
                        <div style="float: left;height: 24px;width: 24px;padding: 12px 0px;">
                          <img style="float: left;height: 24px;width: 24px;" :src="platformImg(item.platformCode)" />
                        </div>
                        <div style="float: left;width: calc(100% - 160px);">
                          <a :href="item.shopUrl" target="_blank" class="a-link">
                            {{ item.shopUrl }}
                          </a>
                        </div>
                        <div v-show="item.shopscore" class="score" style="float: right;">
                          信用积分
                          <span style="font-size: 20px;font-weight: 600;padding-left: 10px;">
                            {{ item.shopscore }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-button size="small" class="btnMore" v-if="isMoreBtn && hcmShopList.length > 0"
                  @click="loadMore('2')">加载更多...</el-button>
                <div class="nodata" v-if="hcmShopList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
              </el-tab-pane>
              <el-tab-pane label="灰名单店铺" name="4" v-if="bmcid == '4316'">
                <el-row :gutter="20">
                  <el-col :span="12" v-for="(item, i) in grayNameList" :key="i">
                    <div
                      style="background-color: white;padding: 20px;height: 65px;margin-bottom: 20px;border-radius: 16px;border: 1px solid #ccc;">
                      <div>
                        <span style="font-size: 16px;font-weight: 600;">
                          {{ item.shopName }}
                        </span>
                        <span style="font-size: 14px;padding-left: 12px;color: #606266;">
                          {{ item.wangwang }}
                        </span>
                      </div>
                      <div style="float: left;height: 48px;line-height: 48px;width: 100%;">
                        <div style="float: left;height: 24px;width: 24px;padding: 12px 0px;">
                          <img style="float: left;height: 24px;width: 24px;" :src="platformImg(item.platformCode)" />
                        </div>
                        <div style="float: left;width: calc(100% - 160px);">
                          <a :href="item.shopUrl" target="_blank" class="a-link">
                            {{ item.shopUrl }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-button size="small" class="btnMore" v-if="isMoreBtn && grayNameList.length > 0"
                  @click="loadMore('4')">加载更多...</el-button>
                <div class="nodata" v-if="grayNameList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
              </el-tab-pane>
              <el-tab-pane label="活动申报情况" name="3">
                <div class="input-wraper">
                  <span>申报时间:</span>&nbsp;
                  <el-date-picker v-model="commitDate" value-format="yyyy-MM-dd HH:mm:ss" size="small" type="daterange"
                    range-separator="~" @change="queryData" start-placeholder="请选择" end-placeholder="请选择"
                    :picker-options="pickerOptions"></el-date-picker>
                </div>
                <el-timeline>
                  <el-timeline-item :timestamp="item.start_time | fullTime" placement="top"
                    v-for="(item, i) in ActivityList" :key="i">
                    <div style="background: #fafafa;border: 1px solid #e9e9e9;height: 58px;line-height: 58px;">
                      <div style="float: left;">
                        <div style="float: left;margin-left: 20px;width: 331px;">
                          活动主题：{{ item.campaign_name }}
                        </div>
                        <div style="float: left;">
                          活动单号：{{ item.activity_number }}
                        </div>
                      </div>
                    </div>
                    <div
                      style="background: #fafafa;border: 1px solid #e9e9e9;border-top: none;height: 174px;line-height: 58px;">
                      <div style="float: left;">
                        <div style="float: left;margin-left: 20px;width: 331px;">
                          平台：{{ item.dict_name }}
                        </div>
                        <div style="float: left;">
                          店铺名称：{{ item.shop_name }}
                        </div>
                      </div>
                      <div style="float: left;">
                        <div style="float: left;margin-left: 20px;width: 331px;">
                          预热时间：{{ item.preheating_time | fullTime }}
                        </div>
                        <div style="float: left;">
                          开始时间：{{ item.start_time | fullTime }}
                        </div>
                      </div>
                      <div style="float: left;">
                        <div style="float: left;margin-left: 20px;width: 331px;">
                          结束时间：{{ item.end_time | fullTime }}
                        </div>
                        <div style="float: left;">
                          活动链接数：{{ item.count }}
                        </div>
                      </div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
                <el-button size="small" class="btnMore" v-if="isMoreBtn2 && ActivityList.length > 0"
                  @click="loadMore('3')">加载更多...</el-button>
                <div class="nodata" v-if="ActivityList.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
              </el-tab-pane>
            </el-tabs>
          </section>


        </div>
      </el-col>
    </el-row>


  </div>
</template>

<script>
import tabsDetail from "./tabsDetail"
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapGetters, mapActions } from 'vuex';
import xinmingm from "../../Brand/ClientCheck/xinmingm"; //编辑
import { getMonthBetween } from "@/libs/date";
import moment from "moment";
import { renderShopName } from "@/libs/renderCommon";

export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  components: { tabsDetail, xinmingm },
  data() {
    return {
      editModalInfo: {},
      bmcid: '',
      isMoreBtn2: false,
      ActivityList: [],//活动申报情况
      commitDate: [],//申报时间
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick: (picker) => {
            this.getRecentDate(picker, 1);
          }
        }, {
          text: '近7日',
          onClick: (picker) => {
            this.getRecentDate(picker, 7);
          }
        }, {
          text: '近15日',
          onClick: (picker) => {
            this.getRecentDate(picker, 15);
          }
        }, {
          text: '近30日',
          onClick: (picker) => {
            this.getRecentDate(picker, 30);
          }
        }, {
          text: '近90日',
          onClick: (picker) => {
            this.getRecentDate(picker, 90);
          }
        }, {
          text: '近365日',
          onClick: (picker) => {
            this.getRecentDate(picker, 365);
          }
        }]
      },
      isEdit: false,
      modalInfo: {},
      activeName: "1",
      isMoreBtn: false,
      query: {
        pageNum: 1,
        pageSize: 10
      },
      dealerId: '',

      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },

      loading: true,
      query: {
        pageNo: 1, pageSize: 10
      },
      hcmShopList: [],
      hcmShopData: [],
      grayNameList: [],
      isType: 1,

      shopdealerid: "",
      gridColumns: [],
      getAddress: "",
    };
  },
  watch: {
    modalInfo(newVal) {
      if (newVal) {
        this.getPointsCycle();
      }
    }
  },
  filters: {
    levelFilter: function (value) {
      value = Number(value);
      if (value == 1) return '一级经销商'
      else if (value == 2) return '二级经销商'
      else if (value == 3) return '三级经销商'
      else if (value == 4) return '四级经销商'
      else if (value == 5) return '五级经销商'
    }
  },
  computed: {
    ...mapGetters(["plateform"]),
  },
  mounted() {
    const userData=JSON.parse(localStorage.getItem('userData'));//获取用户信息
    this.userData=userData
    this.bmcid = this.userData.bmcid
  },
  created() {
    
    this.getTree()
  },
  methods: {
    showEdit(isShow) {
      this.isEdit = isShow;
    },
    reqDetail(payload) {
      this.$emit('reqDetail', payload)
    },
    getRecentDate(picker, n) {
      if (!n) {
        n = 90
      }
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if (picker) {
        picker.$emit('pick', [start, end]);
      }
      this.commitDate[0] = this.$options.filters['fullTime'](start);
      this.commitDate[1] = this.$options.filters['fullTime'](end);
    },
    // 获取动态数据
    initTableColum() {
      let query = { module: "DEALER" }
      fetchGet("/hcm/hcmCustomModel/getBybmcidAndModule", query).then(res => {
        this.gridColumns = [];
        this.basicField = [];
        this.addField = [];
        if (res.status == "10000") {
          this.forColum(res.data.add.data.concat(res.data.basic.data))
        }
      });
    },
    // 初始化动态数据
    forColum(titles) {
      titles.sort(this.compare("sort"))
      for (var i = 0; i < titles.length; i++) {
        let field = {
          id: titles[i].id,
          label: titles[i].fieldname,
          prop: titles[i].fieldvalue ? titles[i].fieldvalue : '',
          isChecked: titles[i].isChecked ? true : false,
          fieldRequired: titles[i].fieldRequired,
          fieldClassify: titles[i].fieldClassify,
          width:
            titles[i].fieldvalue == 'address' ? 400 : 320
        }
        if (titles[i].isChecked) {
          this.gridColumns.push(field)
        }
        if (titles[i].fieldClassify == "basic") {
          if (titles[i].fieldvalue == "address") {  //如果存在address的地址字段，就手动添加一个下拉选择的地址字段，用来渲染表单的下拉地址控件
            let addressField = {
              label: "地址",
              prop: "selectAddress",
              isChecked: titles[i].isChecked ? 1 : 0,
              fieldRequired: titles[i].fieldRequired == '1' ? '1' : 0,
              fieldClassify: 'basic',
            }
            this.basicField.push(addressField)
          }
          this.basicField.push(field)
        }
        if (titles[i].fieldClassify == "add") {
          this.addField.push(field)
        }
      }
      for (let i = 0; i < this.gridColumns.length; i++) {
        // 渲染地址字段
        this.renderAddress(this.gridColumns[i]);
        // 经销商名称(点击可查看详情)
        renderShopName(this.gridColumns[i], 'dealername', null, this);
      }
      let hlevelid = Number(this.hcmShopData.hlevelid) == 0 ? null : Number(this.hcmShopData.hlevelid)
      this.editModalInfo = {
        flag: "edit",
        props: this.basicField.concat(this.addField),
        basicform: {
          ...this.hcmShopData,
          dealerid: this.hcmShopData.id,
          selectAddress: this.hcmShopData.address,
          hlevelid: hlevelid,
          level: Number(this.hcmShopData.level)
        },
        addform: this.hcmShopData,
        addField: this.addField,
        row: this.modalInfo.detail,
        // ispanelEdit: index || index === 0 ?  false : true,
        ispanelEdit: true,
      }
    },
    // 表头排序
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop]; if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      }
    },
    // 字段为address的时候拼接：province + city + strict + address
    renderAddress(gridColumns) {
      if (gridColumns.prop == 'address') {
        let province = this.modalInfo.detail.province ? this.modalInfo.detail.province : '';
        let city = this.modalInfo.detail.city ? this.modalInfo.detail.city : '';
        let strict = this.modalInfo.detail.strict ? this.modalInfo.detail.strict : '';
        let address = this.modalInfo.detail.address ? this.modalInfo.detail.address : '';
        return this.getAddress = province + city + strict + address
      }
    },
    // 获取积分周期时间
    getPointsCycle() {
      fetch({
        url: "hcm/hcmReport/getPointsCycle",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          if (this.modalInfo.detail && this.modalInfo.detail.status == 1) {
            this.switchValue = true
          } else {
            this.switchValue = false
          }
          if (res.data) {
            this.getNowDataRang(res.data)
          }
        }
      })
    },
    // 积分周期时间筛选
    getNowDataRang(data) {
      this.integralCycel = data;
      const formatType = "YYYY-MM-DD";
      let now = moment(new Date()).format(formatType).slice(0, 7);
      this.integralCycel.map((item, index) => {
        let time = item.split("--");
        let result = getMonthBetween(time[0], time[1]);
        for (let key in result) {
          result[key].map((v) => {
            if (v === now) {
              this.activeDate = item;
            }
          });
        }
      });
    },
    // 活动申报情况数据请求
    ActivityListData(url, query) {
      this.loading = true;
      fetchGet(url, query).then(res => {
        if (res.status == "10000") {
          if (res.data.details) {
            this.ActivityList = res.data.details;
            if (res.data.details.length < this.query.pageSize)
              this.isMoreBtn2 = false;
            else this.isMoreBtn2 = true;
          }
          this.loading = false;
        }
      });
    },
    queryData(date) {
      let query = {
        pageNum: 1,
        pageSize: 100,
        begintime: date[0],
        endtime: date[1],
        dealer_id: this.modalInfo.detail.id,
      }
      let url = "/hcm/campgign/getCampaignsituation";
      this.ActivityListData(url, query);
    },
    // 授权店铺数据请求
    hcmShopListData(url, query) {
      this.loading = true;
      fetchGet(url, query).then(res => {
        if (res.status == "10000") {
          if (res.data.length < this.query.pageSize)
            this.isMoreBtn = false;
          else this.isMoreBtn = true;
          this.hcmShopList = res.data;
        }
        this.loading = false;
      });
    },
    //灰名单店铺数据请求
    hcmGrayShopListData(url, query) {
      this.loading = true;
      fetchGet(url, query).then(res => {
        if (res.status == "10000") {
          if (res.data.length < this.query.pageSize)
            this.isMoreBtn = false;
          else this.isMoreBtn = true;
          this.grayNameList = res.data;
        }
        this.loading = false;
      });
    },
    // 编辑
    editHandle() {
      this.isEdit = true;
      console.log(123)
      console.log(this.modalInfo.detail)
      let payload = {
        index: null, row: this.modalInfo.detail
      }
      this.$emit('editClick', payload)
    },
    handleClick(tab) {
      let url = "/hcm/campgign/getCampaignsituation"
      let query = {
        dealer_id: this.dealerId,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
      }
      if (tab.name == "3") {  //活动申报情况
        let query = {
          dealer_id: this.dealerId,
          pageNum: this.query.pageNo,
          pageSize: this.query.pageSize,
        }
        this.ActivityListData(url, query);
      } else if (tab.name == "2") {  //授权店铺
        url = "/hcm/hcmShop/GetList"
        query = {
          pageNo: 1,
          pageSize: this.query.pageSize,
          dealerid: this.dealerId
        }
        this.hcmShopListData(url, query)
      } else if (tab.name == "4") {  //授权店铺
        url = "/hcm/hcmShop/GetListblack"
        query = {
          pageNo: 1,
          pageSize: this.query.pageSize,
          dealerid: this.dealerId
        }
        this.hcmGrayShopListData(url, query)
      }
    },
    loadMore(index) {
      if (index == 2) {
        this.query.pageSize = this.query.pageSize + 10;
        this.handleClick({ name: "2" });
      } else if (index == 3) {
        this.query.pageSize = this.query.pageSize + 10;
        this.handleClick({ name: "3" });
      } else if (index == 4) {
        this.query.pageSize = this.query.pageSize + 10;
        this.handleClick({ name: "4" });
      }
    },
    treeClick(data, node) {

      if (data.shop_name) {
        this.tabClick(data.id)
        this.$refs.tabs.activeChange()
      } else {
        this.activeName = "1"
        this.dealerId = data.id
        this.findById(data.id)
        this.isType = 2
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    platformImg(platformCode) {
      let img = "";
      try {
        img = require('@/assets/img/platform/pla_' + platformCode + '.png')
      } catch (err) {
        img = ""
      }
      return img
    },
    // 获取树数据
    getTree() {
      fetch({
        url: "hcm/hcmShop/getTree",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.treeData = res.data
          // 初始化加载经销商数据
          this.isType = 2
          this.dealerId = this.treeData[0].id
          this.findById(this.treeData[0].id)
        }
      }).catch(err => {

      })
    },
    // 获取经销商数据
    findById(id) {
      this.dealerId = id
      let params = {
        dealerid: id
      }
      fetch({
        url: "hcm/dealer/findById",
        method: "get",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        console.log(res.status)
        if (res.status == '10000') {
          console.log(res)
          this.loading = false
          this.hcmShopData = res.data;
          // this.modalInfo = res.data;
          this.modalInfo = {
            isShow: true,
            detail: res.data,
          }
          this.initTableColum();
        }
      }).catch(err => {

      })
    },
    // 店铺数据请求
    getById(query) {
      fetchGet("/hcm/hcmShop/getById", query).then(res => {
        if (res.status == "10000") {
          this.hcmShopData = res.data;
          console.log(this.hcmShopData)
          this.isType = 1
        }
      });
    },
    tabClick(id) {
      this.shopdealerid = id;
      console.log(id)
      let query = {
        shopId: id
      }
      this.getById(query);
      this.$refs.tabs.getFildData('SHOP');
      this.$refs.tabs.reqBasicInfo(query);
      this.$refs.tabs.reqTabsData(id);
    },
  }
};
</script>

<style lang="scss">
.a-link {
  float: left;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(64, 158, 255);
  text-decoration: none;
  line-height: 58px;
  margin-left: 10px;
}

.card-wrap {
  height: 180px;
  padding: 38px 0 0 0;

  .el-carousel__arrow {
    background: #fff;
    top: calc(50% - 19px);

    i {
      font-size: 28px !important;
      color: #d9d9d9 !important;
    }
  }

  .tabs {
    padding: 0 50px;
  }

  .tabs_item {
    width: 90%;
    min-width: 306px;
    height: 140px;
    border-radius: 12px;
    box-shadow: 0 0 5px rgba(102, 102, 102, 0.3);
    background-color: #ffffff;
    display: block;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    padding: 10px 20px;
    box-sizing: border-box;
    margin: 0 auto;
    cursor: pointer;
    transition: all .5s;

    &:hover {
      transform: scale(1.02, 1.05)
    }

    &.index0 {
      border-top: 7px solid #36cbcb;

      &.active {
        box-shadow: 0 10px 12px -2px #b6caca;
        transform: scale(1.02, 1.05)
      }
    }

    &.index1 {
      border-top: 7px solid #975fe4;

      &.active {
        box-shadow: 0 10px 12px -2px #cac1d8;
        transform: scale(1.02, 1.05)
      }
    }

    &.index2 {
      border-top: 7px solid #fad337;

      &.active {
        box-shadow: 0 10px 12px -2px #ece6cb;
        transform: scale(1.02, 1.05)
      }
    }

    p {
      margin: 0;
      padding: 0;
      color: #333333;
      line-height: 38px;
    }

    p.title {
      font-size: 18px;
    }

    p.content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #666;

      span {
        font-size: 14px;
      }

      .wangwang {
        font-size: 16px;

        img {
          vertical-align: middle;
          margin-right: 5px;
          width: 20px;
          height: 20px;
        }
      }

      .credit-score {
        font-size: 36px;
        vertical-align: text-bottom;
      }
    }
  }
}

.tabs-wrapper {
  padding: 0;

  .el-tabs__nav-wrap,
  .el-tabs__content {
    padding: 0 30px 0 30px;
  }

  .el-timeline {
    padding: 0;
  }
}
</style>
